// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"entities-m__wrapper__3vYrn"};